import LongText from '../../Elements/LongText';
import UserNameComponent from '../../Elements/UserNameComponent';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import urlHelper from '../../Helpers/urlHelper';
import React from 'react';
import AuthService from '../../Services/authService';
import TpCreditMemoStatusEnum from '../../Enums/CreditMemoStatusEnum';
import DataTableActionMenu from '../../Elements/DataTable/DataTableActionMenu';
import FieldTypesEnum from '../../Enums/FieldTypesEnum';

export default class TpCreditMemoItem {
  constructor(item) {
    if (item) {
      this.TpClientInvoiceId = item.tpClientInvoiceId;
      this.CaspianClientId = item.caspianClientId;
      this.CaspianClientName = item.caspianClientName;
      this.TpCreditMemoId = item.tpCreditMemoId;
      this.BareInvoiceId = item.bareInvoiceId;
      this.OfficeName = item.officeName;
      this.CreditAmount = item.creditAmount;
      this.CreditAmountNoTax = item.creditAmountNoTax;
      this.NumberOfItemsCredited = item.numberOfItemsCredited;
      this.Status = item.status;
      this.Reason = item.reason;
      this.OldReason = item.reason; //Used during edit process
      this.SubmittedBy = item.submittedBy;
      this.AssignedTo = item.assignedTo;
      this.AssignedToName = `${item.assignedToFirstName} ${item.assignedToLastName}`;
      this.Yrmo = item.yrmo;
      this.Description = item.description;
      this.CurrencyCode = item.currencyCode;
      this.InternalReferenceNumber = item.internalReferenceNumber;
      this.InternalInformation = item.internalInformation;

      this.FinalizedOnUtc = item.finalizedOnUtc;
      this.TpClientInvoiceStatus = item.tpClientInvoiceStatus;
      this.CreatedBy = item.createdBy;
      this.CreatedOnUtc = item.createdOnUtc;
      this.AssignedOnUtc = item.assignedOnUtc;
      this.ApprovedBy = item.approvedBy;
      this.ApprovedOnUtc = item.approvedOnUtc;
      this.Supervisor = item.supervisor;
      this.CreditMemoApprover = item.creditMemoApprover;
      this.IsInfoRequested = item.isInfoRequested;
    } else {
      this.TpClientInvoiceId = null;
      this.CaspianClientId = null;
      this.CaspianClientName = '';
      this.TpCreditMemoId = null;
      this.BareInvoiceId = '';
      this.OfficeName = '';
      this.CreditAmount = 0;
      this.CreditAmountNoTax = 0;
      this.NumberOfItemsCredited = 0;
      this.Status = '';
      this.Reason = '';
      this.OldReason = null; //Used during edit process
      this.AssignedToName = '';
      this.Yrmo = '';
      this.Description = '';
      this.CurrencyCode = '';
      this.InternalReferenceNumber = '';
      this.InternalInformation = '';

      this.FinalizedOnUtc = '';
      this.TpClientInvoiceStatus = '';
      this.CreatedBy = '';
      this.CreatedOnUtc = '';
      this.AssignedOnUtc = '';
      this.ApprovedBy = '';
      this.ApprovedOnUtc = '';
      this.Supervisor = '';
      this.CreditMemoApprover = '';
      this.IsInfoRequested = false;
    }
    this.Selected = false;
  }

  static nameOfTheItemDetailList() {
    return 'Third-Party Credit Memo';
  }

  static MoneyFields = ['CreditAmount'];
  static Currency() {
    return 'CurrencyCode';
  }
  static MoneyFieldsSecondary = ['CreditAmount'];
  static CurrencySecondary() {
    return 'Currency';
  }
  static DateFields = ['FinalizedOnUtc', 'CreatedOnUtc', 'AssignedOnUtc', 'ApprovedOnUtc'];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { label: 'Credit Memo ID', name: 'TpCreditMemoId', className: 'text-left' },
        { label: 'Internal Reference', name: 'InternalReferenceNumber', className: 'text-left' },
        { label: 'Status', name: 'Status', className: 'text-left' },
        { label: 'BARE #', name: 'BareInvoiceId', className: 'text-left' },
        { label: 'Finalized On', name: 'FinalizedOnUtc', className: 'text-left' },
        { label: 'Reason', name: 'Reason', className: 'text-left' },
        { label: 'Client Invoice #', name: 'TpClientInvoiceId', className: 'text-left' },
        { label: 'Client Invoice Status', name: 'TpClientInvoiceStatus', className: 'text-left' },
        {
          label: 'Client',
          name: (item) => `${item.CaspianClientName} (${item.CaspianClientId})`,
          className: 'text-left',
        },
        { label: '# Items Credited', name: 'NumberOfItemsCredited', className: 'text-left' },
        {
          label: 'Gross Credit Amount',
          name: 'CreditAmount',
          className: 'text-left',
        },
        {
          label: 'YRMO',
          name: 'Yrmo',
          className: 'text-left',
        },
        {
          label: 'Description',
          name: 'Description',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
        },
        {
          label: 'Internal Information',
          name: 'InternalInformation',
          width: TabListTableCellWidthEnum.TwoLines,
          className: 'text-left',
        },
        { label: 'Created By', name: (item) => <UserNameComponent userId={item.CreatedBy} />, className: 'text-left' },
        { label: 'Assigned To', name: 'AssignedToName', className: 'text-left' },
        {
          label: 'Approved By',
          name: (item) => <UserNameComponent userId={item.ApprovedBy} />,
          className: 'text-left',
        },
        { label: 'Created On', name: 'CreatedOnUtc', className: 'text-left' },
        { label: 'Assigned On', name: 'AssignedOnUtc', className: 'text-left' },
        { label: 'Approved On', name: 'ApprovedOnUtc', className: 'text-left' },
        { label: 'Supervisor', name: (item) => <UserNameComponent userId={item.Supervisor} />, className: 'text-left' },
        {
          label: 'Credit Memo Approver',
          name: (item) => <UserNameComponent userId={item.CreditMemoApprover} />,
          className: 'text-left',
        },
        { label: '', name: '', className: 'text-left' },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Client Name', orderById: 'CaspianClientName', data: 'CaspianClientName' },
      {
        label: 'Credit Memo ID',
        orderById: 'TpCreditMemoId',
        data: TpCreditMemoItem.GetDetailCellContent,
        minWidth: 70,
      },
      { label: 'BARE #', orderById: 'BareInvoiceId', data: 'BareInvoiceId', minWidth: 70 },
      { label: 'Office', orderById: 'OfficeName', data: 'OfficeName' },
      {
        label: 'Gross Credit',
        orderById: 'CreditAmount',
        data: 'CreditAmount',
      },
      { label: '# Items Credited', orderById: 'NumberOfItemsCredited', data: 'NumberOfItemsCredited', minWidth: 110 },
      { label: 'Status', orderById: 'Status', data: 'Status' },
      { label: 'Reason', orderById: 'Reason', data: 'Reason' },
      { label: 'Assigned To', orderById: 'AssignedToName', data: 'AssignedToName' },
      { label: 'YRMO', orderById: 'ClientInvoiceYrmo', data: 'ClientInvoiceYrmo' },
      {
        label: 'Description',
        orderById: 'Description',
        data: (item) => (
          <LongText
            text={item.Description}
            maxLength={50}
          />
        ),
      },
      {
        label: ' ',
        orderById: '',
        data: TpCreditMemoItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
        className: 'text-center',
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            text: 'Edit',
            onClick: () => TpCreditMemoItem.editFunction(item.TpCreditMemoId, item),
            iconName: 'fa-solid fa-edit',
            roleKey: 'tpcreditmemo_editandstatuschange',
            disabled:
              item.Status === TpCreditMemoStatusEnum.Declined || item.Status === TpCreditMemoStatusEnum.Finalized,
          },
          {
            iconName: 'fa-solid fa-retweet',
            text: 'Status Change',
            roleKey: 'tpcreditmemo_editandstatuschange',
            onClick: () => TpCreditMemoItem.statusChangeFunction(item.TpCreditMemoId, item),
            disabled:
              item.Status === TpCreditMemoStatusEnum.Declined ||
              item.Status === TpCreditMemoStatusEnum.Finalized ||
              (item.SubmittedBy !== AuthService.getInstance().GetLoggedInUser().userId &&
                item.AssignedTo !== AuthService.getInstance().GetLoggedInUser().userId &&
                !AuthService.IsAdmin()),
          },
        ]}
      />
    );
  }

  static statusChangeFunction = () => {
    alert('Empty function');
  };

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.TpCreditMemoId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'tpcreditmemodetails',
      `id=${item.TpCreditMemoId}`,
      'Open up in a new tab'
    );
  }
}
